import { SettingsPermissions } from "@redotech/account-common/permissions";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { IntegrationsHubRedirect } from "../integrations-hub-redirect";

export const customerAccountSettingsRoutes: PermissionedRouteObject[] = [
  {
    handle: {
      breadcrumb: "Ad blocks",
      permission: SettingsPermissions.SET_CUSTOMER_ACCOUNTS_SETTINGS,
    },
    path: "customer-accounts-ad-blocks",
    children: [
      {
        index: true,
        lazy: async () => {
          const { AdBlocksPage } =
            await import("../../../../setting/customer-accounts/ad-blocks/ad-blocks-drawer");
          return { Component: AdBlocksPage };
        },
      },
      {
        path: ":adBlockId",
        handle: {
          breadcrumb: "Edit Ad Block",
          permission: SettingsPermissions.SET_CUSTOMER_ACCOUNTS_SETTINGS,
        },
        lazy: async () => {
          const { AdBlockBuilder } =
            await import("../../../../setting/customer-accounts/ad-blocks/ad-blocks-builder");
          return { element: <AdBlockBuilder /> };
        },
      },
    ],
  },
  {
    handle: {
      breadcrumb: "Integrations",
      permission: SettingsPermissions.SET_CUSTOMER_ACCOUNTS_SETTINGS,
    },
    path: "customer-accounts-integrations",
    element: <IntegrationsHubRedirect to="../integrations" />,
  },
  {
    handle: {
      breadcrumb: "Storefront display",
      permission: SettingsPermissions.SET_CUSTOMER_ACCOUNTS_SETTINGS,
    },
    path: "customer-accounts-storefront-display",
    lazy: async () => {
      const { StorefrontDisplaysPage } =
        await import("../../../../setting/customer-accounts/storefront-displays");
      return { Component: StorefrontDisplaysPage };
    },
  },
];
